import SingleCourse from './SingleCourse';

export default SingleCourse;
